/**
 * Returns true if the subject is a number
 * @param subject
 */
export default function isObject(subject) {
    return typeof subject === 'object';
}
